module.exports = {
      id: "bus-usage",
      viewBox: "0 0 512 239",
      url: __webpack_public_path__ + "images/sprites/transport.svg#bus-usage",
      toString: function () {
        return this.url;
      }
    }